export const CALENDAR_EVENT_NOTIFICATION_STATUS_EMAIL_SENT = 1 // calendar event email was sent
export const CALENDAR_EVENT_NOTIFICATION_STATUS_EMAIL_READ = 2 // calendar event email was read
